import { api } from "../lib/axios"

export async function JobsFn() {
  const response = await api.get('jobs')

  return response.data
}